<div class="gtfs-container">

    <mat-card class="gtfs-card">
        <mat-card-header class="card-header">

            <mat-card-title class="gtfs-title"> GTFS Builder</mat-card-title>
            <mat-card-subtitle class="gtfs-subtitle">Convert your bus schedules to GTFS format</mat-card-subtitle>

            <div class="gtfs-buttons-container">
                <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" />
                <button mat-raised-button (click)="fileInput.click()" class="gtfs-buttons upload-button">Upload bus
                    schedule</button>

                @if (dataValid()) {
                <button mat-flat-button (click)="navigateToMap()" class="gtfs-buttons">View on
                    Map</button>
                <button mat-flat-button (click)="downloadGTFS()">Build GTFS and
                    Download</button>
                }
            </div>

        </mat-card-header>
        <mat-card-content>


            @if (dataValid() && performance()) {
            <div class=" performance-metrics">
                <p> Time taken to process file: <b>{{ performance().toFixed(2) }} ms</b> </p>
            </div>
            }


            @if (dataValid()) {
            <mat-tab-group>
                <!-- <mat-tab label="Overview">
                    Data Overview comes in here
                </mat-tab> -->

                <mat-tab label="Overview">
                    <app-overview></app-overview>
                </mat-tab>
                <mat-tab label="Agency">
                    <agency-details></agency-details>
                </mat-tab>
                <mat-tab label="Calendar">
                    <calendar-details></calendar-details>
                </mat-tab>
                <mat-tab label="Routes">
                    <data-table datatype="routes"></data-table>
                </mat-tab>
                <mat-tab label="Trips">
                    <data-table datatype="trips"></data-table>
                </mat-tab>
                <mat-tab label="Stops">
                    <data-table datatype="stops"></data-table>
                </mat-tab>
                <mat-tab label="Stop Times">
                    <data-table datatype="stop_times"></data-table>
                </mat-tab>
                <mat-tab label="Shapes">
                    <data-table datatype="shapes"></data-table>
                </mat-tab>
            </mat-tab-group>
            } @else {
            <div class="data-error">
                <h2>No data available</h2>
                <p>Please upload bus schedule data to view the GTFS data.</p>
            </div>
            }
        </mat-card-content>
    </mat-card>

</div>